import { Skeleton } from "../ui/skeleton";

export default function JoinSkeleton() {
  return (
    <div className="flex md:px-20 w-full h-dvh items-center justify-center max-w-[1000px] m-auto">
      <div className="animate-pulse text-muted-foreground w-full p-2 flex flex-col md:flex-row items-center gap-2">
        <Skeleton className="border w-full md:w-1/2 h-64" />
        <div className="flex flex-col items-center justify-center gap-2 md:w-1/2">
          <Skeleton className="border w-52 h-6 mt-10" />
          <Skeleton className="border w-36 h-3" />
          <Skeleton className="border w-24 h-3" />
          <div className="flex gap-2 mt-5">
            <Skeleton className="border w-10 h-10" />
            <Skeleton className="border w-10 h-10" />
          </div>
          <Skeleton className="border w-24 h-8" />
          {/* {t("loading")} */}
        </div>
      </div>
    </div>
  );
}
